import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import useAudioManager from '../../../hooks/useAudioManager'

const EventBanner = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { playSound } = useAudioManager({
    click: 'buttonClick'
  })

  return (
    <button
      type="button"
      onClick={() => {
        playSound('click')
        navigate('/event')
      }}
      className="w-full text-left rounded-2xl overflow-hidden border border-sky-300/30 bg-gradient-to-br from-sky-500/15 via-amber-500/10 to-emerald-500/15 hover:border-sky-200/60 transition-all active:scale-[0.99]"
    >
      <div className="relative">
        <img
          src="/images/event/event-major-poster.jpg"
          className="w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-white-950/85 via-white-950/25 to-transparent" />
      </div>
      <div className="p-4">
        <div className="text-lg font-black text-white leading-snug tracking-wide">
          {t('event.major.title', 'Major Cologne: Командная Заруба')}
        </div>
        <div className="mt-1 text-sm text-sky-100/80">
          <span className="inline-flex items-center gap-1">
            {t('event.major.description', 'Открывай кейсы любимых команд, поднимай их в топ и забирай шанс на скины до $3000!')}
          </span>
        </div>
      </div>
    </button>
  )
}

export default EventBanner
